import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
`

export const ColorContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-left: var(--space-350);
`

export const ColorItemContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

export const InputContainer = styled.div`
  cursor: pointer;
`

export const ChevronContainer = styled.div`
  display: flex;
  position: absolute;
  color: var(--text-secondary);
  right: var(--space-350);
  top: 50%;
  transform: translateY(-50%);
`
